import { Link } from 'react-router-dom';

export default function BrandIntro() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative aspect-[4/3] rounded-xl overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Elegant%20Asian%20lifestyle%20scene%20with%20handcrafted%20ceramics%20and%20silk%20textiles%20and%20tea%20set%20on%20a%20beautiful%20wooden%20table%2C%20warm%20natural%20lighting%2C%20minimalist%20Asian%20aesthetic%2C%20harmonious%20composition%20with%20traditional%20and%20modern%20elements&width=800&height=600&seq=brand-intro-01&orientation=landscape"
              alt="亚洲精品品牌理念 - 甄选亚洲匠心精品"
              title="亚洲精品 - 汇聚东方美学，品味精致生活"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <p className="text-sm text-primary-500 font-medium tracking-wider mb-3">
              关于亚洲精品
            </p>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-5">
              汇聚东方美学<br />
              <span className="text-primary-500">品味精致生活</span>
            </h2>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
              亚洲精品诞生于对东方美学的深深热爱。我们走遍日本京都的丝绸老铺、韩国首尔的独立设计工作室、中国景德镇的千年瓷窑、泰国清迈的手工艺村落，只为寻找那些真正承载着匠心与文化的精品。
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-6">
              每一件入选亚洲精品的商品，都需要经过我们的六道甄选流程：产地溯源、工艺评估、品质检测、设计评审、文化价值评估和用户体验测试。我们相信，真正的精品不仅仅是商品，更是文化的载体、匠心的表达。
            </p>
            <div className="flex flex-col sm:flex-row items-start sm:items-center gap-6 mb-6">
              <div>
                <p className="text-2xl font-heading font-bold text-accent-600">500+</p>
                <p className="text-xs text-foreground-500 mt-1">精选品牌</p>
              </div>
              <div className="hidden sm:block w-px h-10 bg-background-300/60" />
              <div>
                <p className="text-2xl font-heading font-bold text-accent-600">10,000+</p>
                <p className="text-xs text-foreground-500 mt-1">甄选精品</p>
              </div>
              <div className="hidden sm:block w-px h-10 bg-background-300/60" />
              <div>
                <p className="text-2xl font-heading font-bold text-accent-600">50万+</p>
                <p className="text-xs text-foreground-500 mt-1">信赖会员</p>
              </div>
            </div>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-2.5 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              了解更多
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}